import getTranslatedText from './getTranslatedText';
export default getTranslatedText;



// WEBPACK FOOTER //
// ./src/services/getTranslatedText/index.js